import React from 'react'
import Connect from '../../components/Connect/connect.jsx';
import './loginPage.css';

function loginPage() {
  return (
    <>
      <Connect/>
    </>
  )
}

export default loginPage